export const uid = () => {
  return 'id_' + Math.random().toString(16).slice(2);
};
